<nav class="fixed top-0 left-0 right-0 z-50 glass-card rounded-none! shadow-lg">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16">
      <!-- Logo & Brand Name -->
      <div class="flex items-center">
        <a routerLink="/" class="flex items-center space-x-2 group">
          <span class="text-2xl font-bold font-elegant tracking-wider bg-linear-to-r from-rainbow-orange via-rainbow-yellow to-rainbow-green bg-clip-text text-transparent group-hover:brightness-110 transition duration-300">
            Дъгата
          </span>
        </a>
      </div>

      <!-- Desktop Navigation -->
      <div class="hidden md:flex items-center space-x-8">
        <a routerLink="/" routerLinkActive="text-brand-primary!" [routerLinkActiveOptions]="{exact: true}"
           class="text-sm font-medium text-dark-text-muted hover:text-white transition duration-200">
          Начало
        </a>
        <a routerLink="/menu" routerLinkActive="text-brand-primary!"
           class="text-sm font-medium text-dark-text-muted hover:text-white transition duration-200">
          Меню
        </a>
        <a routerLink="/delivery-info" routerLinkActive="text-brand-primary!"
           class="text-sm font-medium text-dark-text-muted hover:text-white transition duration-200">
          Доставка
        </a>
        @if (authService.isAdmin()) {
          <a routerLink="/admin" routerLinkActive="text-brand-primary!"
             class="text-sm font-medium text-rainbow-yellow hover:brightness-110 transition duration-200 flex items-center space-x-1">
            <span>🛡️ Админ</span>
          </a>
        }
      </div>

      <!-- Cart & Auth Buttons -->
      <div class="flex items-center space-x-4">
        <!-- Shopping Cart Button -->
        <a routerLink="/checkout" class="relative p-2 text-dark-text-muted hover:text-white transition duration-200">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          @if (cartService.itemCount() > 0) {
            <span class="absolute -top-1 -right-1 bg-rainbow-red text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-md animate-pulse">
              {{ cartService.itemCount() }}
            </span>
          }
        </a>

        <!-- Auth Status Desktop -->
        <div class="hidden md:block">
          @if (authService.isAuthenticated()) {
            <div class="flex items-center space-x-4">
              <a routerLink="/profile" class="text-sm font-medium text-dark-text-muted hover:text-white transition duration-200 flex items-center space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span class="truncate max-w-30">{{ authService.user()?.displayName }}</span>
              </a>
              <button (click)="authService.logout()" class="text-xs text-red-400 hover:text-red-300 font-medium transition duration-200 cursor-pointer">
                Изход
              </button>
            </div>
          } @else {
            <a routerLink="/auth" class="bg-btn-rainbow text-white px-5 py-2 rounded-full text-sm font-medium shadow-lg hover:shadow-orange-500/20 cursor-pointer">
              Вход
            </a>
          }
        </div>

        <!-- Mobile Menu Toggle -->
        <button (click)="toggleMobileMenu()" class="md:hidden p-2 text-dark-text-muted hover:text-white transition duration-200 cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            @if (mobileMenuOpen()) {
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            } @else {
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            }
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu -->
  @if (mobileMenuOpen()) {
    <div class="md:hidden border-t border-white/5 bg-dark-surface/95 backdrop-blur-lg px-2 pt-2 pb-3 space-y-1">
      <a routerLink="/"
         routerLinkActive="text-brand-primary!"
         [routerLinkActiveOptions]="{exact: true}"
         (click)="closeMobileMenu()"
         class="block px-3 py-2 rounded-md text-base font-medium text-dark-text-muted hover:text-white hover:bg-white/5"
      >
        Начало
      </a>
      <a routerLink="/menu"
         (click)="closeMobileMenu()"
         routerLinkActive="text-brand-primary!"
         class="block px-3 py-2 rounded-md text-base font-medium text-dark-text-muted hover:text-white hover:bg-white/5"
      >
        Меню
      </a>
      <a routerLink="/delivery-info"
         (click)="closeMobileMenu()"
         routerLinkActive="text-brand-primary!"
         class="block px-3 py-2 rounded-md text-base font-medium text-dark-text-muted hover:text-white hover:bg-white/5"
      >
        Доставка
      </a>
      @if (authService.isAdmin()) {
        <a routerLink="/admin" (click)="closeMobileMenu()" class="block px-3 py-2 rounded-md text-base font-medium text-rainbow-yellow hover:bg-white/5">
          🛡️ Админ Панел
        </a>
      }
      <div class="border-t border-white/5 my-2 pt-2">
        @if (authService.isAuthenticated()) {
          <div class="px-3 py-1 flex items-center justify-between">
            <a routerLink="/profile" (click)="closeMobileMenu()" class="text-sm font-medium text-white flex items-center space-x-2">
              <span>{{ authService.user()?.displayName }}</span>
            </a>
            <button (click)="authService.logout(); closeMobileMenu()" class="text-xs text-red-400 font-medium cursor-pointer">
              Изход
            </button>
          </div>
        } @else {
          <a routerLink="/auth" (click)="closeMobileMenu()" class="block text-center bg-btn-rainbow text-white mx-3 my-1 py-2 rounded-full text-base font-medium shadow-md cursor-pointer">
            Вход / Регистрация
          </a>
        }
      </div>
    </div>
  }
  <div class="h-0.5 w-full bg-linear-to-r from-rainbow-red via-rainbow-orange to-rainbow-purple"></div>
</nav>
